export default {
  namespaced: true,
  state: {
    salesTypical: [],
    salesTicket: [],
    sales: [],
    sale: null,
    actions: {},
    currentActions: null,
  },
  actions: {
    // eslint-disable-next-line consistent-return
    GetSale({ commit, state }, saleID) {
      commit('setField', { name: 'sale', value: null });
      if (state.salesTypical.length || state.salesTicket.length) {
        if (saleID !== null) {
          const sale = state.salesTypical.find(item => item.id === saleID)
            || state.salesTicket.find(item => item.id === saleID);
          sale && commit('setField', { name: 'sale', value: sale });
          return sale;
        }
        return null;
      }
    },
    GetSales({ commit, rootGetters }, payload) {
      commit('setField', { name: 'salesTypical', value: [] });
      commit('setField', { name: 'salesTicket', value: [] });
      rootGetters.axl.post('sales/api/sale/list', payload).then((response) => {
        commit('setField', {
          name: 'salesTypical',
          value: response.data.sales.typical,
        });
        commit('setField', {
          name: 'salesTicket',
          value: response.data.sales.ticket,
        });
      });
    },
    GetActions({ commit, rootGetters }, payload) {
      commit('setField', { name: 'actions', value: {} });
      rootGetters.axl
        .post('actions/api/action/actual', payload)
        .then((response) => {
          commit('setField', { name: 'actions', value: response.data.actions });
        });
    },
    GetAction({ commit, rootGetters }, payload) {
      rootGetters.axl
        .post('actions/api/action/view', payload)
        .then((response) => {
          commit('setField', { name: 'action', value: response.data.action });
        });
    },
    GetActionsList({ commit, rootGetters }, payload) {
      rootGetters.axl
        .post('actions/api/action/current-list', payload)
        .then((response) => {
          commit('setField', {
            name: 'currentActions',
            value: response.data.actions,
          });
        });
    },
    ConfirmAction({ dispatch, rootGetters }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl
          .post('/actions/api/action/take-part', {
            profile_id: payload.profile_id,
            action_id: payload.action_id,
          })
          .then((response) => {
            dispatch('GetActionsList', { profile_id: payload.profile_id });
            resolve(response);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
